module.exports = __webpack_public_path__ + "static/media/image.334c2bac.jpeg";